var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEthxDark = function SvgEthxDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6 10c0 5.523-4.299 10-9.6 10C4.696 20 .4 15.523.4 10S4.696 0 10 0c5.301 0 9.6 4.477 9.6 10Zm-5.487 7.82 3.394-3.535-1.614-1.681c-.648 1.588-1.87 2.861-3.394 3.535l1.614 1.682Zm-6.168-1.504-1.558 1.623-3.395-3.536 1.31-1.364c.754 1.53 2.06 2.718 3.643 3.277Zm-3.84-8.92c.648-1.588 1.87-2.86 3.395-3.535L6.193 2.5 2.8 6.035l1.307 1.362Zm8.813-3.331c1.469.785 2.608 2.145 3.145 3.795L17.7 6.154l-3.394-3.536-1.388 1.447Z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ethx_dark_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.002 4.167-.065.228v6.613l.065.067 2.946-1.815-2.946-5.093Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.001 4.167 7.055 9.26 10 11.075V4.167Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.001 11.655-.036.046v2.356l.036.11 2.948-4.325-2.948 1.813Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.001 14.167v-2.512L7.055 9.842 10 14.167Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.002 11.074 2.946-1.814-2.946-1.395v3.21Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.055 9.26 10 11.074V7.865L7.055 9.26Z",
    fill: "#393939"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ethx_dark_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(5.2 4.167)",
    d: "M0 0h9.6v10H0z"
  })))));
};
export default SvgEthxDark;